// extracted by mini-css-extract-plugin
module.exports = {"container":"PracticeBanner_container__1TG19","img":"PracticeBanner_img__2NDJC","date":"PracticeBanner_date__28wKO","details":"PracticeBanner_details__3tbQ0"};